import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { apiRequest } from "../../Api/Api";
import { ENDPOINTS } from "../../Api/Endpoints";
import { persistPatientUploadFlowState } from "../../utils/patientUploadFlowSession";
import "./RequestFlow.scss";

/**
 * Creates an empty DRAFT match request and starts the linear upload flow.
 */
export default function RequestNew() {
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    const start = async () => {
      let resolvedId = "";
      try {
        const res = await apiRequest({
          method: "POST",
          url: ENDPOINTS.CREATE_DRAFT_MATCH_REQUEST,
          data: { prescriptionIds: [] },
        });
        resolvedId = String(res?.matchRequestId || res?.data?.matchRequestId || "");
      } catch {
        // Backend draft endpoint may be unavailable in some environments.
      }
      if (!resolvedId) {
        resolvedId = `local-${Date.now()}`;
      }
      if (cancelled) return;
      persistPatientUploadFlowState({ linearMatchRequestId: resolvedId, startFlow: true, uploadedDocIds: [] });
      navigate(`/request/${resolvedId}/upload`, {
        replace: true,
        state: { linearMatchRequestId: resolvedId, startFlow: true, uploadedDocIds: [] },
      });
    };
    void start();
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return <div className="reqUploadShim">Starting your request…</div>;
}
